import { Component, EventEmitter, ViewEncapsulation, OnInit, Output, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import {
	DynamicDatacenterFilter,
	DatacenterBooleanFilter,
	DatacenterBooleanFilterType,
	DatacenterCodeTranslationFilterType,
} from '../../../models/datacenter-filters';
import { pageTransitions } from '../../../animations/page-transitions';

@Component({
	selector: 'copo-boolean-filter',
	templateUrl: './view-boolean-filter.component.html',
	styleUrl: './view-boolean-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, MatButtonModule]
})
export class ViewBooleanFilterComponent implements DynamicDatacenterFilter<DatacenterBooleanFilter>, OnInit {
	@Input() filter?: DatacenterBooleanFilter;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;
	isFilterTrueOnInit = false;

	ngOnInit() {
		if (!this.filter) {
			return;
		}
		if (this.isValidDatacenterCodeTranslationFilterTypeArray(
				<DatacenterCodeTranslationFilterType[]> this.filter.getValues()
		)
		) {
			const arrayOfValues = [];
			const filteredValues = this.convertValues(<DatacenterCodeTranslationFilterType[]> this.filter.getValues());
			for (let i = 0; i < this.filter.buttonLabels.length; i++) {
				if (this.filter.fixedValues) {
					arrayOfValues.push({
						apiName: this.filter.apiNames[0],
						selected: false,
						value: this.filter.fixedValues[i]
					});
				}
			}
			for (const item of arrayOfValues) {
				const [firstFilteredValue] = filteredValues;
				if (Array.isArray(firstFilteredValue)) {
					const selectedItem = firstFilteredValue.find(filteredVal => filteredVal.value === item.value);
					item.selected = selectedItem?.selected ?? false;
				} else {
					item.selected = false;
				}
			}
			this.filter.addValues([arrayOfValues]);
		}
		if (this.filter.getValues()[0].length === 1) {
			this.isFilterTrueOnInit = true;
		}
	}

	isValidDatacenterCodeTranslationFilterTypeArray(
		arr: DatacenterCodeTranslationFilterType[]
	) {
		return arr.every(item =>
			typeof item === 'object'
			&& Object.hasOwn(item, 'code') && Object.hasOwn(item, 'translation'));
	}

	convertValues(filterValues: DatacenterCodeTranslationFilterType[]) {
		return [
			filterValues.map(item => ({
				apiName: this.filter?.apiNames[0],
				value: item.code,
				selected: true
			}))
		];
	}

	removeValue(index: number) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(index, 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return { id: this.filter.filterId, values: this.filter.getValues() };
		}
		return undefined;
	}

	buttonClick(checkboxValue: DatacenterBooleanFilterType) {
		checkboxValue.selected = !checkboxValue.selected;
	}
}
